import * as React from 'react';
import { isNil } from 'lodash';

import { ModalOpener } from 'components/modal';
import PageHeading from 'components/page/page-heading/PageHeading';
import OfferShippingInfo from 'modules/subcampaigns/components/offer-shipping-info/OfferShippingInfo';
import EditShippingModal, { MODE_EDIT_ADDRESS } from 'modules/shipping/components/edit-shipping-modal/EditShippingModal';

import { addUserAction } from 'modules/tracking/providers/user-action-provider';

import { __t, applyTranslations } from 'utils/language';

import './offer-shipping-card.scss';

applyTranslations(require('./offer-shipping-card.i18n.json'));

import type { OrganizationSettingsForm, ShippingAddress } from 'types';

type Props = {
  isOfferAccepted: boolean,
  isForBrand: boolean,
  subcampaignId: number,
  includesDelivery: boolean,
  headingClass: string,
  shippingAddress: ShippingAddress | undefined | null,
  influencerOrganizationSettings: OrganizationSettingsForm
};

type State = {
  isAddressModalShown: boolean
};

class OfferShippingCard extends React.Component<Props, State> {
  state: State = {
    isAddressModalShown: true
  };

  handleToggled = (isExpanded: boolean) => {
    const { isForBrand } = this.props;
    const event = isForBrand
      ? 'offer-shipping-card-expanded-by-brand'
      : 'offer-shipping-card-expanded-by-influencer';

    if (isExpanded) {
      addUserAction({
        eventCategory: 'offers',
        eventAction: event
      });
    }
  };

  handleCloseAddressModal = () => {
    this.setState({ isAddressModalShown: false });
  };

  render() {
    const {
      headingClass,
      includesDelivery,
      isOfferAccepted,
      influencerOrganizationSettings,
      shippingAddress,
      subcampaignId,
      isForBrand
    } = this.props;
    const { isAddressModalShown } = this.state;

    const needToShowAddressModal = !isForBrand && isOfferAccepted && includesDelivery && isNil(shippingAddress?.recipient);

    return (
      <React.Fragment>
        <PageHeading
          heading={
            includesDelivery
              ? __t('offer_shipping_card.shipping_and_contact_details')
              : __t('offer_shipping_card.no_shipping_and_contact_details')
          }
          size="h3"
          margin="none"
          customClass={headingClass}
        />
        {needToShowAddressModal && (
          <ModalOpener
            open={isAddressModalShown}
            showClose
            onClose={this.handleCloseAddressModal}
          >
            <EditShippingModal
              onCloseModal={this.handleCloseAddressModal}
              subcampaignId={subcampaignId}
              shippingAddress={shippingAddress ?? undefined} // replace possible null with undefined
              mode={MODE_EDIT_ADDRESS}
            />
          </ModalOpener>
        )}
        <OfferShippingInfo
          isForBrand={isForBrand}
          subcampaignId={subcampaignId}
          includesDelivery={includesDelivery}
          shippingAddress={shippingAddress}
          onToggled={this.handleToggled}
          isOfferAccepted={isOfferAccepted}
          influencerOrganizationSettings={influencerOrganizationSettings}
        />
      </React.Fragment>
    );
  }
}

export default OfferShippingCard;
